/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown> }} Seo_Endpoint_Q_AgentInputs */

const en_seo_endpoint_q_agent = /** @type {(inputs: Seo_Endpoint_Q_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Can an AI agent use the ${i?.name} ${i?.action} API?`)
};

const zh_hans1_seo_endpoint_q_agent = /** @type {(inputs: Seo_Endpoint_Q_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI 智能体可以使用 ${i?.name} ${i?.action} API 吗？`)
};

const pt_br2_seo_endpoint_q_agent = /** @type {(inputs: Seo_Endpoint_Q_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Um agente de IA pode usar o endpoint ${i?.action} da API para ${i?.name}?`)
};

const es_seo_endpoint_q_agent = /** @type {(inputs: Seo_Endpoint_Q_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Puede un agente de IA usar el endpoint ${i?.action} de la API de ${i?.name}?`)
};

const fr_seo_endpoint_q_agent = /** @type {(inputs: Seo_Endpoint_Q_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un agent IA peut-il utiliser l’API ${i?.name} ${i?.action} ?`)
};

const de_seo_endpoint_q_agent = /** @type {(inputs: Seo_Endpoint_Q_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kann ein KI-Agent die ${i?.name}-${i?.action}-API nutzen?`)
};

const ru_seo_endpoint_q_agent = /** @type {(inputs: Seo_Endpoint_Q_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Может ли ИИ-агент использовать API ${i?.name} ${i?.action}?`)
};

const it_seo_endpoint_q_agent = /** @type {(inputs: Seo_Endpoint_Q_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un agente IA può usare l'API ${i?.name} ${i?.action}?`)
};

/**
* | output |
* | --- |
* | "Can an AI agent use the {name} {action} API?" |
*
* @param {Seo_Endpoint_Q_AgentInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_q_agent = /** @type {((inputs: Seo_Endpoint_Q_AgentInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_Q_AgentInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_q_agent(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_q_agent(inputs)
	if (locale === "es") return es_seo_endpoint_q_agent(inputs)
	if (locale === "fr") return fr_seo_endpoint_q_agent(inputs)
	if (locale === "de") return de_seo_endpoint_q_agent(inputs)
	if (locale === "ru") return ru_seo_endpoint_q_agent(inputs)
	if (locale === "it") return it_seo_endpoint_q_agent(inputs)
	return en_seo_endpoint_q_agent(inputs)
});